import { useState } from 'react';
import { setClientType } from '../lib/cms-products/products';
import { LegalFormEnum, LegalFormEnumMap } from '../models/enums/legal-form.enum';
import type { FormVariant } from '../context/client-request-form/client-request-form.types';
import type { OpfType } from '../components/common-components/company-suggestion/company-suggestion.types';

export const useLeadFormValidation = () => {
    const [isButtonBlocked, setIsButtonBlocked] = useState(false);
    const [hasAddressError, setHasAddressError] = useState(false);
    const [hasOrganizationFieldError, setHasOrganizationFieldError] = useState(false);

    const shouldValidateOrganizationField = (currentVariant: FormVariant, opf?: OpfType) => {
        const clientType = setClientType(currentVariant, opf);
        return clientType !== LegalFormEnumMap[LegalFormEnum.SELF_EMPLOYEE] && hasOrganizationFieldError;
    };

    return {
        isButtonBlocked,
        setIsButtonBlocked,
        hasAddressError,
        setHasAddressError,
        hasOrganizationFieldError,
        setHasOrganizationFieldError,
        shouldValidateOrganizationField,
    };
};
